import * as React from "react";
import { MbnIcon } from "../../MbnIcon";
export const renderMbnIcon = (tagNumber, componentPrefix) => {
    return React.createElement(MbnIcon, { tagNumber: tagNumber, componentPrefix: componentPrefix });
};
//# sourceMappingURL=renderMbnIcon.js.map